import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';

const MyOrders = () => {
    const orderOtpServiceActive = useSelector(state => state.companyState);

    const [show, setShow] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [orderPendingList, setOrderPendingList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);

    const dispatch = useDispatch();
    const getOrderList = async () => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/OrderMaster/orderDetailByUserId?userId=${authData.user_id}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                setOrderList(response.orderMasterData)
                setOrderPendingList(response.orderMasterPendingData)
            }
            else {
                if (response.message === "Invalid Token") {
                    navigate("/Login");
                    dispatch(resetToken());
                    dispatch(allRemoveItem());
                }
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }
    const hanldeProductDetail = (prodId) => {
        debugger;
        console.log(prodId)
        navigate("/ProductDetail", { state: { productId: prodId } });
    }
    const handleNavigration = (orderId) => {
        setShow(false);
        navigate("/order-tracking", { state: { orderId: orderId } });
    }

    const onHandleCancelOrder = async (orderId) => {
        setShow(false);

        if (orderOtpServiceActive.company_order_otp_active) {  
            sendOtp(userDetail.user_email,orderId)
            //navigate("/verifyCancellation", { state: { orderId: orderId, user_email: userDetail.user_email } })
        } else {
            navigate("/ordercancel", { state: { orderId: orderId } });
        }
    }


 const sendOtp = async(email,orderId) => {
        try {

            const response = await apiService.get(`/api/admin/User_Detail/GenerateEmailOTP?email=${email}&otp_purpose=Order Cancellation`)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                let redirectParams = {orderId: orderId, user_email: userDetail.user_email}          
            navigate("/otp",{state : { cancelOrderData : redirectParams, purpose:"CancelOrder"}})

            }
            else {
                return false;
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    };


    useEffect(() => {

        if (authData.login) {
            getOrderList()
        }
    }, [])

// Status mappings
const OrderStatus = {
    0: "Pending",
    1: "Partially Processed",
    2: "Processing Done",
    3: "Partially Shipped",
    4: "Shipping Done",
    5: "Delivery Started",
    6: "Out for Delievery",
    7: "Partially Delivered",
    8: "Delivered",
    9: "Partially Cancelled",
    10: "Cancelled",
    11: "Partially Returned",
    12: "Returned",
    13: "Partially Completed",
    14: "Completed"
};

const OrderStatusColors = {
    0: "gray",
    1: "#3498db",
    2: "#2980b9",
    3: "#f1c40f",
    4: "#f39c12",
    5: "#9b59b6",
    6: "#8e44ad",
    7: "#2ecc71",
    8: "#27ae60",
    9: "#e67e22",
    10: "#e74c3c",
    11: "#95a5a6",
    12: "#7f8c8d",
    13: "#1abc9c",
    14: "#16a085"
};

const OrderItemStatusLabels = {
    0: "Not processed till now",
    1: "Processing",
    2: "Shipping in process",
    3: "Delivery Started",
    4: "Delivered",
    5: "Cancelled",
    6: "Returned",
  };

  const OrderItemStatusColors = {
    0: "#6c757d",   // Pending - Gray
    1: "#007bff",   // Processing - Blue
    2: "#17a2b8",   // Shipping - Cyan
    3: "#fd7e14",   // Delivery Started - Orange
    4: "#28a745",   // Delivered - Green
    5: "#dc3545",   // Cancelled - Red
    6: "#6f42c1",   // Returned - Purple
  };

    return (
        <>
         <section className="user-dashboard-section section-b-space">
    <div className="container-fluid-lg">
        <div className="row">
            <div className="col-xxl-12 col-lg-12">
                <div className="dashboard-right-sidebar">
                    <div className="dashboard-order">
                        <div className="title">
                            <h2>My Orders History</h2>
                            <span className="title-leaf title-leaf-gray">
                                <svg className="icon-width bg-gray">
                                    <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                </svg>
                            </span>
                        </div>

                        <div className="order-contain justify-content-center">
                            {orderList.length !== 0 ? (
                                <>
                                    {orderList.map((item, index) => (
                                        <div
                                            className="order-box dashboard-bg-box shadow-sm"
                                            key={index}
                                            style={{ width: "100%" }}
                                        >
                                            <div className="order-container d-flex justify-content-between align-items-center border-bottom">
                                                <div className="order-detail">
                                                    <h5 className='fw-bold' style={{ color: OrderStatusColors[item.order_status] }}>
                                                    <i className="fa fa-circle fa-xs    " /> {OrderStatus[item.order_status]}
                                                    </h5>
                                                    <h6 className='fw-bold'>
                                                        Date:{" "}
                                                        {item.created_on
                                                            ? new Date(item.created_on).toLocaleString("en-US", {
                                                                  year: "numeric",
                                                                  month: "long",
                                                                  day: "numeric",
                                                              })
                                                            : ""}
                                                    </h6>
                                                    <h6 className='fw-bold'>Order ID: {item.order_number}</h6>
                                                </div>
                                            </div>

                                            <table className="table bordered">
                                                <tbody>
                                                    {item.orderItemMasters.map((itemData, key) => (
                                                        <tr key={key}>
                                                            <td style={{ width: "30%" }}>
                                                                <img
                                                                    style={{ height: "10vh" }}
                                                                    src={
                                                                        process.env.REACT_APP_API_BASE_URL +
                                                                        itemData.img_url
                                                                    }
                                                                    className="img-fluid"
                                                                    alt={itemData.product_title}
                                                                />
                                                                
                                                            </td>
                                                            <td>
                                                                <h6>{itemData.product_title}</h6>
                                                                
                                                                <h6 className="text-content">
                                                                    Price : ₹{itemData.sp_after_tax}
                                                                </h6>
                                                                <h6 className="text-content">
                                                                    Qty : {itemData.quantity}
                                                                </h6>

                                                                <h6 className='mt-1' style={{ color: OrderItemStatusColors[itemData.order_status] }}>
                                                    <i className="fa fa-circle fa-xs" /> {OrderItemStatusLabels[itemData.order_status]}
                                                    </h6>
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                <NavLink
                                                                    to="/order-tracking"
                                                                    state={{
                                                                        orderId: item.id,
                                                                        productId: itemData.product_id,
                                                                    }}
                                                                    className="nav-link text-success fw-bold"
                                                                >
                                                                    <i className="fa fa-arrow-right ms-2" />
                                                                </NavLink>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className='float-end'>

                                                    {item.order_status < 3 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => onHandleCancelOrder(item.id)}
                                                            className="btn btn-animation mt-3"
                                                        >
                                                            Cancel Order
                                                        </button>
                                                    )} 
                                             
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <div className="text-center mt-5">
                                    <h2>No Orders placed till now...</h2>
                                </div>
                            )}

                            <button
                                onClick={() => {
                                    navigate("/");
                                }}
                                className="btn btn-animation proceed-btn fw-bold w-100 mt-4"
                            >
                                <i className="fa-solid fa-arrow-left me-2" />
                                Continue Shopping ...
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

        </>
    )
}

export default MyOrders;